import { render, staticRenderFns } from "./AddLiveCourse.vue?vue&type=template&id=2a4edf7c&scoped=true"
import script from "./AddLiveCourse.vue?vue&type=script&lang=ts"
export * from "./AddLiveCourse.vue?vue&type=script&lang=ts"
import style0 from "./AddLiveCourse.vue?vue&type=style&index=0&id=2a4edf7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4edf7c",
  null
  
)

export default component.exports